import Vue from 'vue';
import Router from 'vue-router';

import router from './router.js';

import historyTag from '@/views/historyTag/';
import service from '@/views/service/';
import setting from '@/views/setting/';
import workReport from '@/views/workReport/';
import chat from '@/views/chat/';
import system from '@/views/system/';
import workOrder from '@/views/workOrder/';
import window from '@/views/window/';

Vue.use(Router);

let RouterModel = new Router({
    mode: 'hash',
    base: '/',
    routes: [...router, ...service, ...setting, ...historyTag, ...workReport, ...chat, ...system, ...workOrder, ...window]
})

RouterModel.beforeEach((to, from, next) => {
    next();
})

RouterModel.afterEach((to, from) => { })

export default RouterModel;


// WEBPACK FOOTER //
// ./src/vue/router/index.js